import React from "react";
import PageShell from "@/components/PageShell";

const Section = ({ title, children, testid }) => (
  <section data-testid={testid} className="mt-12 first:mt-0">
    <h2 className="font-display text-2xl lg:text-3xl font-light text-[#E6D5B8] mb-5">
      {title}
    </h2>
    <div className="text-[15px] lg:text-base text-[#F9F6F0]/75 font-light leading-relaxed space-y-4">
      {children}
    </div>
  </section>
);

const Legal = () => {
  return (
    <PageShell testid="legal-page">
      <article className="max-w-3xl mx-auto px-6 lg:px-10 pt-12 pb-16">
        <div className="flex items-center gap-3 mb-6">
          <span className="h-px w-10 bg-[#E6D5B8]" />
          <span className="text-[11px] tracking-luxury uppercase text-[#E6D5B8] font-medium">
            Documento legal
          </span>
        </div>
        <h1 className="font-display text-4xl sm:text-5xl font-light leading-[1.05]">
          Aviso Legal y{" "}
          <span className="italic text-[#E6D5B8]">Términos de Uso</span>
        </h1>
        <p className="mt-5 text-sm text-[#F9F6F0]/55">
          Última actualización: febrero 2026
        </p>

        <div className="mt-14">
          <Section title="1. Identidad de la firma" testid="legal-identity">
            <p>
              <strong className="text-[#F9F6F0] font-semibold">
                EMB Consulting Group
              </strong>{" "}
              es la denominación comercial bajo la cual el suscrito Marco S.
              Equis (titular de la cédula B emitida por la Comisión Nacional de
              Seguros y Fianzas — CNSF, número C404868) opera como{" "}
              <strong className="text-[#F9F6F0] font-semibold">
                Promotoría Allianz México No. 559
              </strong>{" "}
              y como intermediario autorizado con clave directa en Skandia
              Operadora de Fondos y Dominion Capital Strategies.
            </p>
            <p>
              Domicilio fiscal y de contacto: Playa del Carmen, Quintana Roo,
              México. Contacto:{" "}
              <a
                href="mailto:atencion@embconsultingroup.com.mx"
                className="text-[#E6D5B8] hover:underline"
              >
                atencion@embconsultingroup.com.mx
              </a>{" "}
              · +52 984 185 9759.
            </p>
          </Section>

          <Section title="2. Naturaleza del servicio" testid="legal-service">
            <p>
              EMB Consulting Group brinda servicios de{" "}
              <strong className="text-[#F9F6F0] font-semibold">
                asesoría e intermediación
              </strong>{" "}
              en planeación financiera personal, ahorro, inversión y protección
              patrimonial. Operamos como promotores e intermediarios
              autorizados; la firma{" "}
              <strong className="text-[#F9F6F0] font-semibold">
                no opera ni custodia
              </strong>{" "}
              recursos del cliente: cada póliza, plan de inversión o vehículo
              patrimonial se contrata directamente entre el cliente y la
              institución financiera o aseguradora correspondiente, conforme a
              los términos, condiciones y reglamentos de cada institución.
            </p>
            <p>
              Las instituciones financieras y aseguradoras mencionadas en este
              sitio se encuentran reguladas por las autoridades financieras de
              México (CNBV, CNSF, CONDUSEF) y/o por las autoridades regulatorias
              de sus países de origen.
            </p>
          </Section>

          <Section title="3. Comisiones e independencia" testid="legal-commissions">
            <p>
              Los ingresos de EMB Consulting Group provienen exclusivamente de
              comisiones declaradas por las instituciones financieras y
              aseguradoras al momento de la contratación de productos por parte
              del cliente. Estas comisiones forman parte del costo de
              adquisición del producto y son informadas al cliente con
              transparencia antes de la firma.
            </p>
            <p>
              La asesoría inicial es{" "}
              <strong className="text-[#F9F6F0] font-semibold">
                gratuita y sin compromiso
              </strong>
              . El cliente conserva en todo momento la decisión final sobre la
              contratación de cualquier producto recomendado.
            </p>
          </Section>

          <Section title="4. Información publicada en el sitio" testid="legal-info">
            <p>
              La información, simulaciones, ejemplos y proyecciones publicadas
              en este sitio web tienen{" "}
              <strong className="text-[#F9F6F0] font-semibold">
                carácter exclusivamente informativo y orientativo
              </strong>
              . No constituyen una recomendación personalizada de inversión, una
              oferta vinculante de contratación, ni una garantía de rendimiento
              futuro.
            </p>
            <p>
              Rendimientos pasados no garantizan rendimientos futuros. Toda
              decisión de inversión, ahorro o contratación de protección
              requiere un análisis personalizado del perfil del cliente que se
              realiza en sesión privada conforme a la metodología EMB.
            </p>
            <p>
              Los logos, denominaciones y marcas comerciales de Allianz,
              Skandia, Dominion Capital Strategies, HDI, AXA, Qualitas, BUPA,
              Olé Life, Atlas, Bx+, Continental, ANA Seguros, MDRT, AMASFAC,
              CNBV, CNSF y CONDUSEF mostradas en este sitio son propiedad de
              sus respectivos titulares y se utilizan únicamente con fines
              identificativos de las relaciones comerciales o institucionales
              referidas.
            </p>
          </Section>

          <Section title="5. Propiedad intelectual" testid="legal-ip">
            <p>
              Los contenidos editoriales propios (textos, análisis, imágenes
              originales, diseño, código de este sitio web) son propiedad de
              EMB Consulting Group. Queda prohibida su reproducción total o
              parcial sin autorización expresa por escrito.
            </p>
          </Section>

          <Section title="6. Limitación de responsabilidad" testid="legal-liability">
            <p>
              EMB Consulting Group no se responsabiliza por: (i) decisiones
              financieras tomadas por el visitante con base únicamente en
              información publicada en este sitio, sin haber concluido una
              sesión personalizada de asesoría; (ii) la disponibilidad,
              continuidad o desempeño de los servicios o productos contratados
              directamente con las instituciones financieras o aseguradoras;
              (iii) interrupciones técnicas del sitio web ajenas a la firma.
            </p>
          </Section>

          <Section title="7. Atención y quejas" testid="legal-cnsf">
            <p>
              Cualquier inconformidad o queja relacionada con productos o
              servicios financieros contratados puede presentarse directamente
              ante la institución correspondiente y/o ante la{" "}
              <strong className="text-[#F9F6F0] font-semibold">
                CONDUSEF (Comisión Nacional para la Protección y Defensa de los
                Usuarios de Servicios Financieros)
              </strong>{" "}
              al teléfono 55 5340 0999 o en{" "}
              <a
                href="https://www.condusef.gob.mx"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#E6D5B8] hover:underline"
              >
                www.condusef.gob.mx
              </a>
              .
            </p>
            <p>
              Para asuntos relacionados con la conducta del intermediario, la
              autoridad competente es la{" "}
              <strong className="text-[#F9F6F0] font-semibold">
                CNSF (Comisión Nacional de Seguros y Fianzas)
              </strong>{" "}
              —{" "}
              <a
                href="https://www.gob.mx/cnsf"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#E6D5B8] hover:underline"
              >
                www.gob.mx/cnsf
              </a>
              .
            </p>
          </Section>

          <Section title="8. Modificaciones" testid="legal-changes">
            <p>
              EMB Consulting Group se reserva el derecho de modificar el
              contenido de este aviso legal cuando lo considere necesario, sin
              previo aviso, publicando la versión vigente en este mismo sitio
              con la fecha de su última actualización.
            </p>
          </Section>

          <Section title="9. Legislación aplicable" testid="legal-jurisdiction">
            <p>
              Este aviso legal se rige por las leyes de los Estados Unidos
              Mexicanos. Cualquier controversia que derive de la interpretación
              o aplicación de los presentes términos se someterá a los
              tribunales competentes de Playa del Carmen, Quintana Roo, México,
              renunciando las partes a cualquier otro fuero que les pudiera
              corresponder.
            </p>
          </Section>

          <div className="mt-16 pt-8 border-t border-white/10 text-xs text-[#A397B4]/80 leading-relaxed">
            Este documento es un borrador base. Debe ser revisado y validado
            por el área legal y de cumplimiento del cliente antes de su uso
            definitivo. La redacción incluye los elementos generalmente
            esperados por la regulación financiera mexicana aplicable a
            intermediarios y promotorías.
          </div>
        </div>
      </article>
    </PageShell>
  );
};

export default Legal;
